module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "official"
  }, [_c('el-dialog', {
    staticClass: "agent-info-form",
    attrs: {
      "title": "",
      "close-on-click-modal": false
    },
    on: {
      "close": _vm.dialogClose
    },
    model: {
      value: (_vm.dialogVisible),
      callback: function($$v) {
        _vm.dialogVisible = $$v
      },
      expression: "dialogVisible"
    }
  }, [_c('el-form', {
    attrs: {
      "label-width": "100px"
    }
  }, [_c('div', {
    staticClass: "v-com-form"
  }, [(_vm.isReadOnly) ? _c('div', {
    staticClass: "v-com-matter"
  }) : _vm._e(), _vm._v(" "), _c('el-row', [_c('h4', [_vm._v("园所基本信息")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "幼儿园名称",
      "required": ""
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.SchoolName),
      callback: function($$v) {
        _vm.$set(_vm.form, "SchoolName", $$v)
      },
      expression: "form.SchoolName"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('area-select', {
    ref: "myareaForm2",
    attrs: {
      "label": "所在区域",
      "label-width": "100px",
      "required": ""
    },
    model: {
      value: (_vm.areaInfo2),
      callback: function($$v) {
        _vm.areaInfo2 = $$v
      },
      expression: "areaInfo2"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "详细地址",
      "required": ""
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.Address),
      callback: function($$v) {
        _vm.$set(_vm.form, "Address", $$v)
      },
      expression: "form.Address"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "label": "所属代理商",
      "prop": "AgentId"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择或搜索",
      "filterable": ""
    },
    model: {
      value: (_vm.form.AgentId),
      callback: function($$v) {
        _vm.$set(_vm.form, "AgentId", $$v)
      },
      expression: "form.AgentId"
    }
  }, _vm._l((_vm.AgentList), function(item) {
    return _c('el-option', {
      attrs: {
        "label": item.Customer,
        "value": item.Id
      }
    })
  }))], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "园所电话",
      "required": ""
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.SchoolPhoneNo),
      callback: function($$v) {
        _vm.$set(_vm.form, "SchoolPhoneNo", $$v)
      },
      expression: "form.SchoolPhoneNo"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "幼儿园人数"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.ChildNum),
      callback: function($$v) {
        _vm.$set(_vm.form, "ChildNum", $$v)
      },
      expression: "form.ChildNum"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "line-height": "38px",
      "padding-left": "15px"
    },
    attrs: {
      "span": 12
    }
  }, [_vm._v("\n                        人\n                    ")])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "学费"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.Tuition),
      callback: function($$v) {
        _vm.$set(_vm.form, "Tuition", $$v)
      },
      expression: "form.Tuition"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "line-height": "38px",
      "padding-left": "15px"
    },
    attrs: {
      "span": 12
    }
  }, [_vm._v("\n                        元/月\n                    ")])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.SchoolPic.length > 0 || !_vm.isReadOnly || _vm.settings.Audit),
      expression: "SchoolPic.length>0||!isReadOnly||settings.Audit"
    }],
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "园所照片"
    }
  }, [_c('div', {
    attrs: {
      "id": "container-1"
    }
  }, [_vm._l((_vm.SchoolPic), function(item) {
    return _c('div', {
      attrs: {
        "id": "ImgPrev"
      }
    }, [_c('div', {
      staticClass: "post-format-content"
    }, [_c('div', {
      staticClass: "post-thumbnail"
    }, [_c('img', {
      staticClass: "attachment-thumbnail wp-post-image",
      attrs: {
        "id": "myProPic",
        "src": item.Url
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "content-wrap"
    }, [_c('span', {
      staticClass: "entry-title"
    }, [_c('span', {
      staticClass: "featured-image"
    }, [_c('i', {
      staticClass: "el-icon-view",
      on: {
        "click": function($event) {
          _vm.viewPicture(item.Url, _vm.SchoolPic)
        }
      }
    }), _vm._v(" "), _c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.isReadOnly),
        expression: "!isReadOnly"
      }],
      staticStyle: {
        "width": "10px",
        "padding": "6px"
      }
    }), _vm._v(" "), _c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.isReadOnly),
        expression: "!isReadOnly"
      }],
      staticClass: "el-icon-delete2",
      on: {
        "click": function($event) {
          _vm.delPicture(item.Url, _vm.SchoolPic)
        }
      }
    })])])])])])
  }), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isReadOnly),
      expression: "!isReadOnly"
    }],
    staticStyle: {
      "width": "80px",
      "height": "80px",
      "float": "left"
    },
    attrs: {
      "icon": "plus",
      "id": "upload-btn-1"
    }
  })], 2)])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.SchoolContract.ProveType !== '' && _vm.SchoolContract.ProveType !== '办园许可证'),
      expression: "SchoolContract.ProveType!=='' && SchoolContract.ProveType!=='办园许可证'"
    }],
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.SchoolContract.ProveType
    }
  }, [_c('div', {
    attrs: {
      "id": "container-2"
    }
  }, _vm._l((_vm.SchoolContract.ProvePics), function(item) {
    return _c('div', {
      attrs: {
        "id": "ImgPrev"
      }
    }, [_c('div', {
      staticClass: "post-format-content"
    }, [_c('div', {
      staticClass: "post-thumbnail"
    }, [_c('img', {
      staticClass: "attachment-thumbnail wp-post-image",
      attrs: {
        "id": "myProPic",
        "src": item.Url
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "content-wrap"
    }, [_c('span', {
      staticClass: "entry-title"
    }, [_c('span', {
      staticClass: "featured-image"
    }, [_c('i', {
      staticClass: "el-icon-view",
      on: {
        "click": function($event) {
          _vm.viewPicture(item.Url, _vm.PermitPic)
        }
      }
    })])])])])])
  }))])], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.SchoolContract.ContractPices.length > 0),
      expression: "SchoolContract.ContractPices.length>0"
    }],
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "合同照片"
    }
  }, [_c('div', {
    attrs: {
      "id": "container-2"
    }
  }, _vm._l((_vm.SchoolContract.ContractPices), function(item) {
    return _c('div', {
      attrs: {
        "id": "ImgPrev"
      }
    }, [_c('div', {
      staticClass: "post-format-content"
    }, [_c('div', {
      staticClass: "post-thumbnail"
    }, [_c('img', {
      staticClass: "attachment-thumbnail wp-post-image",
      attrs: {
        "id": "myProPic",
        "src": item.Url
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "content-wrap"
    }, [_c('span', {
      staticClass: "entry-title"
    }, [_c('span', {
      staticClass: "featured-image"
    }, [_c('i', {
      staticClass: "el-icon-view",
      on: {
        "click": function($event) {
          _vm.viewPicture(item.Url, _vm.PermitPic)
        }
      }
    })])])])])])
  }))])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.PermitPic.length > 0 || !_vm.isReadOnly || _vm.settings.Audit),
      expression: "PermitPic.length>0||!isReadOnly||settings.Audit"
    }],
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "办园许可证"
    }
  }, [_c('div', {
    attrs: {
      "id": "container-2"
    }
  }, [_vm._l((_vm.PermitPic), function(item) {
    return _c('div', {
      attrs: {
        "id": "ImgPrev"
      }
    }, [_c('div', {
      staticClass: "post-format-content"
    }, [_c('div', {
      staticClass: "post-thumbnail"
    }, [_c('img', {
      staticClass: "attachment-thumbnail wp-post-image",
      attrs: {
        "id": "myProPic",
        "src": item.Url
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "content-wrap"
    }, [_c('span', {
      staticClass: "entry-title"
    }, [_c('span', {
      staticClass: "featured-image"
    }, [_c('i', {
      staticClass: "el-icon-view",
      on: {
        "click": function($event) {
          _vm.viewPicture(item.Url, _vm.PermitPic)
        }
      }
    }), _vm._v(" "), _c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.isReadOnly),
        expression: "!isReadOnly"
      }],
      staticStyle: {
        "width": "10px",
        "padding": "6px"
      }
    }), _vm._v(" "), _c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.isReadOnly),
        expression: "!isReadOnly"
      }],
      staticClass: "el-icon-delete2",
      on: {
        "click": function($event) {
          _vm.delPicture(item.Url, _vm.PermitPic)
        }
      }
    })])])])])])
  }), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isReadOnly),
      expression: "!isReadOnly"
    }],
    staticStyle: {
      "width": "80px",
      "height": "80px",
      "float": "left"
    },
    attrs: {
      "icon": "plus",
      "id": "upload-btn-2"
    }
  })], 2)])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.contractPic.length > 0 || !_vm.isReadOnly || _vm.settings.Audit),
      expression: "contractPic.length>0||!isReadOnly||settings.Audit"
    }],
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "开课申请表"
    }
  }, [_c('div', {
    attrs: {
      "id": "container-3"
    }
  }, [_vm._l((_vm.contractPic), function(item) {
    return _c('div', {
      attrs: {
        "id": "ImgPrev"
      }
    }, [_c('div', {
      staticClass: "post-format-content"
    }, [_c('div', {
      staticClass: "post-thumbnail"
    }, [_c('img', {
      staticClass: "attachment-thumbnail wp-post-image",
      attrs: {
        "id": "myProPic",
        "src": item.Url
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "content-wrap"
    }, [_c('span', {
      staticClass: "entry-title"
    }, [_c('span', {
      staticClass: "featured-image"
    }, [_c('i', {
      staticClass: "el-icon-view",
      on: {
        "click": function($event) {
          _vm.viewPicture(item.Url, _vm.contractPic)
        }
      }
    }), _vm._v(" "), _c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.isReadOnly),
        expression: "!isReadOnly"
      }],
      staticStyle: {
        "width": "10px",
        "padding": "6px"
      }
    }), _vm._v(" "), _c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.isReadOnly),
        expression: "!isReadOnly"
      }],
      staticClass: "el-icon-delete2",
      on: {
        "click": function($event) {
          _vm.delPicture(item.Url, _vm.contractPic)
        }
      }
    })])])])])])
  }), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isReadOnly),
      expression: "!isReadOnly"
    }],
    staticStyle: {
      "width": "80px",
      "height": "80px",
      "float": "left"
    },
    attrs: {
      "icon": "plus",
      "id": "upload-btn-3"
    }
  })], 2)])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.equipmentPic.length > 0 || !_vm.isReadOnly || _vm.settings.Audit),
      expression: "equipmentPic.length>0||!isReadOnly||settings.Audit"
    }],
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "设备照片"
    }
  }, [_c('div', {
    attrs: {
      "id": "container-4"
    }
  }, [_vm._l((_vm.equipmentPic), function(item) {
    return _c('div', {
      attrs: {
        "id": "ImgPrev"
      }
    }, [_c('div', {
      staticClass: "post-format-content"
    }, [_c('div', {
      staticClass: "post-thumbnail"
    }, [_c('img', {
      staticClass: "attachment-thumbnail wp-post-image",
      attrs: {
        "id": "myProPic",
        "src": item.Url
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "content-wrap"
    }, [_c('span', {
      staticClass: "entry-title"
    }, [_c('span', {
      staticClass: "featured-image"
    }, [_c('i', {
      staticClass: "el-icon-view",
      on: {
        "click": function($event) {
          _vm.viewPicture(item.Url, _vm.equipmentPic)
        }
      }
    }), _vm._v(" "), _c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.isReadOnly),
        expression: "!isReadOnly"
      }],
      staticStyle: {
        "width": "10px",
        "padding": "6px"
      }
    }), _vm._v(" "), _c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.isReadOnly),
        expression: "!isReadOnly"
      }],
      staticClass: "el-icon-delete2",
      on: {
        "click": function($event) {
          _vm.delPicture(item.Url, _vm.equipmentPic)
        }
      }
    })])])])])])
  }), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isReadOnly),
      expression: "!isReadOnly"
    }],
    staticStyle: {
      "width": "80px",
      "height": "80px",
      "float": "left"
    },
    attrs: {
      "icon": "plus",
      "id": "upload-btn-4"
    }
  })], 2)])], 1)], 1), _vm._v(" "), (!this.settings.official && _vm.ApplyPicList.length > 0 || !_vm.isReadOnly || _vm.settings.Audit) ? _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "平台开通申请表"
    }
  }, _vm._l((_vm.ApplyPicList), function(item) {
    return _c('div', {
      attrs: {
        "id": "ImgPrev"
      }
    }, [_c('div', {
      staticClass: "post-format-content"
    }, [_c('div', {
      staticClass: "post-thumbnail"
    }, [_c('img', {
      staticClass: "attachment-thumbnail wp-post-image",
      attrs: {
        "id": "myProPic",
        "src": item.Url
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "content-wrap"
    }, [_c('span', {
      staticClass: "entry-title"
    }, [_c('span', {
      staticClass: "featured-image"
    }, [_c('i', {
      staticClass: "el-icon-view",
      on: {
        "click": function($event) {
          _vm.viewPicture(item.Url, _vm.ApplyPicList)
        }
      }
    })])])])])])
  }))], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "20px",
      "text-align": "center"
    }
  }, [_c('el-radio-group', {
    attrs: {
      "size": "medium"
    },
    model: {
      value: (_vm.tabRadioId),
      callback: function($$v) {
        _vm.tabRadioId = $$v
      },
      expression: "tabRadioId"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": "1"
    }
  }, [_vm._v("联系人信息")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "2"
    }
  }, [_vm._v("收货信息")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "3"
    }
  }, [_vm._v("网络情况")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "4"
    }
  }, [_vm._v("数据类型")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "v-com-form"
  }, [(_vm.isReadOnly) ? _c('div', {
    staticClass: "v-com-matter"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tabRadioId == 1),
      expression: "tabRadioId==1"
    }]
  }, [_c('h4', [_vm._v("联系人信息")]), _vm._v(" "), _c('el-form', {
    attrs: {
      "label-width": "84px"
    }
  }, [_c('el-row', [_c('h5', [_vm._v("联系人-1")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "园长名称",
      "required": ""
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.C_name),
      callback: function($$v) {
        _vm.$set(_vm.form, "C_name", $$v)
      },
      expression: "form.C_name"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "园长电话",
      "required": ""
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.C_tel),
      callback: function($$v) {
        _vm.$set(_vm.form, "C_tel", $$v)
      },
      expression: "form.C_tel"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Email"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.C_email),
      callback: function($$v) {
        _vm.$set(_vm.form, "C_email", $$v)
      },
      expression: "form.C_email"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "QQ"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.C_QQ),
      callback: function($$v) {
        _vm.$set(_vm.form, "C_QQ", $$v)
      },
      expression: "form.C_QQ"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "微信"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.C_weixin),
      callback: function($$v) {
        _vm.$set(_vm.form, "C_weixin", $$v)
      },
      expression: "form.C_weixin"
    }
  })], 1)], 1)], 1), _vm._v(" "), _vm._l((_vm.contactList), function(info, index) {
    return _c('link-info', {
      ref: 'contactInfo' + (index + 1),
      refInFor: true,
      attrs: {
        "value": info,
        "myIndex": (index + 2),
        "isReadOnly": _vm.isReadOnly
      },
      on: {
        "delContactfn": _vm.delContactfn
      }
    })
  }), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isReadOnly),
      expression: "!isReadOnly"
    }],
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-button', {
    attrs: {
      "type": "text",
      "icon": "plus"
    },
    on: {
      "click": _vm.addContactObj
    }
  }, [_vm._v("添加联系人")])], 1)], 2)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tabRadioId == 2),
      expression: "tabRadioId==2"
    }]
  }, [_c('h4', [_vm._v("收货信息")]), _vm._v(" "), _c('el-form', {
    ref: "ruleForm",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules,
      "label-width": "100px"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "收货人",
      "prop": "Consignee"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "93.5%"
    },
    attrs: {
      "placeholder": "请输入收货人名称"
    },
    model: {
      value: (_vm.form.Consignee),
      callback: function($$v) {
        _vm.$set(_vm.form, "Consignee", $$v)
      },
      expression: "form.Consignee"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "收货人电话",
      "label-width": "96px",
      "prop": "ConsigneeTel"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "90.5%"
    },
    attrs: {
      "placeholder": "请输入电话号码"
    },
    model: {
      value: (_vm.form.ConsigneeTel),
      callback: function($$v) {
        _vm.$set(_vm.form, "ConsigneeTel", $$v)
      },
      expression: "form.ConsigneeTel"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('area-select', {
    ref: "myareaForm",
    attrs: {
      "label": "收货区域",
      "label-width": "100px",
      "required": ""
    },
    model: {
      value: (_vm.areaInfo),
      callback: function($$v) {
        _vm.areaInfo = $$v
      },
      expression: "areaInfo"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    staticClass: "details-addr",
    attrs: {
      "label": "收货地址",
      "prop": "ConsigneeAdress"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "93%"
    },
    attrs: {
      "placeholder": "请输入收货地址"
    },
    model: {
      value: (_vm.form.ConsigneeAdress),
      callback: function($$v) {
        _vm.$set(_vm.form, "ConsigneeAdress", $$v)
      },
      expression: "form.ConsigneeAdress"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tabRadioId == 3),
      expression: "tabRadioId==3"
    }]
  }, [_c('h4', [_vm._v("网络情况")]), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin-left": "20px"
    }
  }, [_c('p', [_vm._v("园所网络供应商？")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-checkbox-group', {
    model: {
      value: (_vm.SchoolContract.NetworkOperatorName),
      callback: function($$v) {
        _vm.$set(_vm.SchoolContract, "NetworkOperatorName", $$v)
      },
      expression: "SchoolContract.NetworkOperatorName"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "label": "电信"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "联通"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "移动"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "其他"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('p', [_vm._v("园所班级是否有网络，一体机是否可以连接?")]), _vm._v(" "), _c('el-checkbox-group', {
    model: {
      value: (_vm.SchoolContract.NetworkType),
      callback: function($$v) {
        _vm.$set(_vm.SchoolContract, "NetworkType", $$v)
      },
      expression: "SchoolContract.NetworkType"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "label": "有线"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "无线"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "无"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.SchoolContract.DistanceName !== ''),
      expression: "SchoolContract.DistanceName!==''"
    }],
    attrs: {
      "span": 24
    }
  }, [_c('p', [_vm._v("班级无网络，从有网络拉到我们一体机电视位置距离预计多少米。")]), _vm._v(" "), _c('el-radio-group', {
    model: {
      value: (_vm.SchoolContract.DistanceName),
      callback: function($$v) {
        _vm.$set(_vm.SchoolContract, "DistanceName", $$v)
      },
      expression: "SchoolContract.DistanceName"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "10米"
    }
  }), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "30米"
    }
  }), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "50米"
    }
  }), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "100米以上"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('p', [_vm._v("设备入园，是否需要IT工程师上门服务（班级有网络不建议选择，需要收服务费）。")]), _vm._v(" "), _c('el-radio-group', {
    model: {
      value: (_vm.SchoolContract.EngineerName),
      callback: function($$v) {
        _vm.$set(_vm.SchoolContract, "EngineerName", $$v)
      },
      expression: "SchoolContract.EngineerName"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "需要工程师上门"
    }
  }), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "不需要,自己解决网络"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tabRadioId == 4),
      expression: "tabRadioId==4"
    }]
  }, [_c('h4', [_vm._v("其他信息")]), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "数据类型",
      "required": ""
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.form.DataType),
      callback: function($$v) {
        _vm.$set(_vm.form, "DataType", $$v)
      },
      expression: "form.DataType"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 0
    }
  }, [_vm._v("测试")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("正式")])], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.DataType == 1),
      expression: "form.DataType==1"
    }],
    attrs: {
      "label": "是否体验",
      "required": ""
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.form.IsExperience),
      callback: function($$v) {
        _vm.$set(_vm.form, "IsExperience", $$v)
      },
      expression: "form.IsExperience"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 0
    }
  }, [_vm._v("否")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("是")])], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.SubjectList.length),
      expression: "SubjectList.length"
    }],
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "项目类型",
      "required": ""
    }
  }, [_c('el-checkbox-group', {
    on: {
      "change": _vm.changeProjectType
    },
    model: {
      value: (_vm.ProjectType),
      callback: function($$v) {
        _vm.ProjectType = $$v
      },
      expression: "ProjectType"
    }
  }, _vm._l((_vm.SubjectList), function(item) {
    return _c('el-checkbox', {
      attrs: {
        "label": item.ProjectTypeId
      }
    }, [_vm._v(_vm._s(item.ProjectTypeName))])
  }))], 1)], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.PolicyList.length > 0),
      expression: "PolicyList.length>0"
    }],
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "政策类型",
      "required": ""
    }
  }, [_c('el-checkbox-group', {
    model: {
      value: (_vm.PolicyType),
      callback: function($$v) {
        _vm.PolicyType = $$v
      },
      expression: "PolicyType"
    }
  }, _vm._l((_vm.PolicyList), function(item) {
    return _c('el-checkbox', {
      attrs: {
        "label": item.PolicyTypeId
      }
    }, [_vm._v(_vm._s(item.PolicyTypeName))])
  }))], 1)], 1)], 1)], 1)]), _vm._v(" "), (this.settings.Audit) ? _c('el-form', {
    ref: "ruleForm",
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "model": _vm.submitform
    }
  }, [_c('el-row', [_c('el-form-item', {
    staticStyle: {
      "font-weight": "bold"
    },
    attrs: {
      "label": "审核信息"
    }
  })], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "审核通过",
      "prop": "AuditStatus",
      "required": ""
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.submitform.AuditStatus),
      callback: function($$v) {
        _vm.$set(_vm.submitform, "AuditStatus", $$v)
      },
      expression: "submitform.AuditStatus"
    }
  }, _vm._l((_vm.auditList), function(item) {
    return _c('el-option', {
      attrs: {
        "label": item.text,
        "value": item.id
      }
    })
  }))], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-form-item', {
    attrs: {
      "label": "审核意见",
      "prop": "AuditOpinion",
      "required": ""
    }
  }, [_c('el-col', {
    attrs: {
      "span": 18
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.submitform.AuditOpinion),
      callback: function($$v) {
        _vm.$set(_vm.submitform, "AuditOpinion", $$v)
      },
      expression: "submitform.AuditOpinion"
    }
  })], 1)], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(!_vm.isReadOnly) ? _c('el-button', {
    on: {
      "click": _vm.dialogClose
    }
  }, [_vm._v("取 消")]) : _vm._e(), _vm._v(" "), (!_vm.isReadOnly) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.officialSubmit
    }
  }, [_vm._v("确 定")]) : _vm._e(), _vm._v(" "), (_vm.Audit) ? _c('el-button', {
    on: {
      "click": _vm.dialogClose
    }
  }, [_vm._v("取 消")]) : _vm._e(), _vm._v(" "), (_vm.Audit) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.officialSubmit
    }
  }, [_vm._v("确 定")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "size": "tiny"
    },
    model: {
      value: (_vm.PictureVisible),
      callback: function($$v) {
        _vm.PictureVisible = $$v
      },
      expression: "PictureVisible"
    }
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "src": _vm.dialogImageUrl
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-06c607bc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/school/components/official/index.vue
// module id = 1372
// module chunks = 1